/*
 * Copyright (c) 2021 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */
import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

interface DateTimeWithTimezoneModel {
  dateTime: string | undefined;
}

export const customEndBeforeStartDateValueValidation = (
  startFormControlName: string,
  endFormControlName: string
) => {
  return (formGroup: AbstractControl): { [key: string]: any } | null => {
    let errors: ErrorModel | null = null;

    const startValue: DateTimeWithTimezoneModel =
      formGroup.get(startFormControlName)?.value;
    const finishValue: DateTimeWithTimezoneModel =
      formGroup.get(endFormControlName)?.value;

    if (startValue && finishValue) {
      const startDateTime = startValue.dateTime;
      const endDateTime = finishValue.dateTime;

      if (moment(endDateTime).isBefore(moment(startDateTime))) {
        errors = {
          severity: ErrorSeverityEnum.error,
          message: 'endBeforeStartDateValidationError',
        };
      }
    }
    return errors ? errors : null;
  };
};
